import { Button, Modal, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { Role } from "../Enums/Roles";
import { useAuth } from "../hooks/AuthContext";
import { InfinityPagination } from "../hooks/Pagination";
import { ManagerSearch, ManagerTable } from "../interfaces/Manager";
import { RequestTable } from "../interfaces/Request";
import { Status } from "../interfaces/Status";
import { TaskCreate } from "../interfaces/Task";
import { CreateTask, GetManagers, GetStatuses } from "../requester/functions";
import { getFullName } from "../utilities/string";
import VO, { VK } from "../utilities/validate";
import DataDate from "./DataInputs/DataDate";
import DataMultiSelect from "./DataInputs/DataMultiSelect";
import DataSelect from "./DataInputs/DataSelect";
import DataTextField from "./DataInputs/DataTextField";

const template: TaskCreate = {
	name: "",
	description: "",
};

interface IProps {
	open: boolean;
	onClose(): void;
	onCreate?(): void;
	userId?: number;
	request?: RequestTable;
}

const CreateTaskModal = (props: IProps) => {
	const [auth] = useAuth();
	const { enqueueSnackbar } = useSnackbar();

	const [task, setTask] = useState<TaskCreate>(template);
	const [urgency, setUrgency] = useState<Status[]>([]);
	const [managers, setManagers] = useState<ManagerTable[]>([]);
	const [watchers, setWatchers] = useState<ManagerTable[]>([]);

	const [searchManager, setSearchManager] = useState<ManagerSearch>({});
	const [searchWatcher, setSearchWatcher] = useState<ManagerSearch>({});

	useEffect(() => {
		setTask((t) => {
			if (props.request) t.id_request = props.request?.id;
			else if (t.id_request) delete t.id_request;
			return { ...t };
		});
	}, [props.request]);

	useEffect(() => {
		GetManagers(
			{
				...(auth.role === Role.manager
					? { filter_by: { admin_and_self: true } }
					: {}),
				search_by: searchManager,
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setManagers(resp.data.data);
				}
			}
		);
	}, [searchManager]);

	useEffect(() => {
		GetManagers(
			{
				search_by: searchWatcher,
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setWatchers(resp.data.data);
				}
			}
		);
	}, [searchWatcher]);

	useEffect(() => {
		GetStatuses({ filter_by: { type: "urgency" } }, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setUrgency(resp.data);
			}
		});
	}, []);

	return (
		<Modal
			open={props.open}
			onClose={props.onClose}
			className="flex items-center  flex-col justify-center  overflow-auto"
		>
			<Paper className="focus-visible:outline-none p-5 max-w-[800px] min-w-[400px]  flex flex-col gap-5">
				<Typography variant="h4">Создание задачи</Typography>
				<DataTextField
					value={task}
					setValue={setTask}
					keyValue="name"
					inputProps={{
						required: true,
						label: "Название",
						error: !VK(task.name),
					}}
				/>
				<DataTextField
					value={task}
					setValue={setTask}
					keyValue="description"
					inputProps={{
						required: true,
						label: "Описание",
						error: !VK(task.description),
					}}
				/>
				<DataDate
					value={task}
					setValue={setTask}
					label="Дата окончания"
					keyValue={"deadline"}
				/>
				{props.request ? (
					<Paper className="flex flex-col gap-2 p-1">
						<Typography>Заявка</Typography>
						<Typography>
							{props.request.candidate.full_name} / {props.request.vacancy.name}
						</Typography>
					</Paper>
				) : null}
				<DataSelect
					label="Срочность"
					list={urgency}
					value={task}
					setValue={setTask}
					keyValue={"id_urgency"}
				/>
				<DataSelect
					label="Ответственный"
					list={managers}
					value={task}
					setValue={setTask}
					keyTitle={"last_name"}
					keyValue={"id_manager"}
				/>
				<DataMultiSelect
					label="Наблюдатели"
					list={watchers}
					value={task}
					setValue={setTask}
					keyItemValue={"id"}
					keyItemTitle={"last_name"}
					renderItemTitle={(item: ManagerTable) =>
						getFullName(item.last_name, item.first_name, item.patronymic)
					}
					keyValue={"watchers"}
				/>
				<Button
					disabled={!VO(task, template)}
					variant="contained"
					onClick={() => {
						CreateTask({ id_candidate: props.userId, ...task }, (resp) => {
							if (resp.status === "ok") {
								enqueueSnackbar("Резюме создано", {
									variant: "success",
								});
								props.onCreate?.();
								props.onClose();
							} else {
								enqueueSnackbar(`Ошибка ${resp.code}, ${resp.message}`, {
									variant: "error",
								});
							}
						});
					}}
				>
					Сохранить
				</Button>
			</Paper>
		</Modal>
	);
};

export default CreateTaskModal;
